<nav ngxNavbarDynamicExpand class="navbar navbar-dark fixed-top bg-dark navbar-expand-md " #nav>
  <div class="container-fluid ">

    <a routerLink="/" class="navbar-brand" style="min-width: 200px">
      <img class="h-100" src="./assets/images/logo.svg" alt="hello one enterprise">
    </a>

    <button class="navbar-toggler" type="button" (click)="collapse.toggle()" aria-label="Toggle navigation">
      <i class="fa fa-bars"></i>
    </button>

    <ngx-navbar-collapse #collapse="ngxNavbarCollapse">

      <div class="navbar-nav  mx-auto d-none d-md-block navbar-text text-white fw-light h5">
        @if (breadcrumbs.length > 0) {
          @for (breadcrumb of breadcrumbs; track $index) {
            <div class="d-inline-block">
              @if (!$first) {
                <i class="fas fa-level-up-alt fa-rotate-90 fa-sm mx-2 align-middle"></i>
              }
              @if (breadcrumb.route) {
                <a class="link-primary text-decoration-none" [routerLink]="breadcrumb.route">
                  <ng-container *ngTemplateOutlet="text"></ng-container>
                </a>
              } @else {
                <ng-container *ngTemplateOutlet="text"></ng-container>
              }

              <ng-template #text>
                <span class="small">{{ breadcrumb.translate ? (breadcrumb.label | translate) : breadcrumb.label }}</span>
              </ng-template>
            </div>
          }
        }

        @if (breadcrumbs.length <= 0) {
          {{ title | translate }}
        }
      </div>

      <div class="col">
        <app-content-header></app-content-header>
      </div>

    </ngx-navbar-collapse>

  </div>
</nav>

<div id="header-height" [style.height.px]="nav.offsetHeight">

</div>
